import { useNavigate } from "react-router-dom";
import { IconPlus, IconDots, IconChevronRight, IconPencil, IconEye } from '@tabler/icons-react';
import Avatar, { genConfig } from 'react-nice-avatar';
import { AgentsList , deleteAgent} from "@/store/actions";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { AppDispatch } from "@/store";

export default function AgentList() {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { agents, loading } = useSelector((state: any) => state.agents);

    useEffect(() => {
        dispatch(AgentsList())
    }, []);
   
    const EditAgent = (id: string, agent: any) => {
        navigate(`/addagents/${id}`, { state: { agent } });
    };
    
    const ViewAgent = (data: any) => {
        const { id, raw_data } = data;
        navigate(`/viewAgent/${id}`, { state: { agent: raw_data, data: data } });
    };

    const UseAgent = (data: any) => {
        const { id, raw_data } = data;
        navigate(`/useAgent/${id}`, { state: { agent: raw_data } });
    };

    const deleteAgents = async (id: any) => {
        try {
          await dispatch(deleteAgent(id)); // Deleting the agent
          await dispatch(AgentsList());    // Fetching the updated list of agents
        } catch (error) {
          console.error("Error deleting agent: ", error);
        }
      };

    const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleToggle = (id: string) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setOpenDropdownId(null);
        }
    };

    useEffect(() => {
        if (openDropdownId !== null) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownId]);

    return (
        <div className="h-full">
            <div className="container">
                <div className="flex w-full flex-row gap-6 items-center justify-between md:p-4">
                    <h2 className="text-gray-900 text-3xl mt-4 font-bold">Agents</h2>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => navigate('/addagents/new')}
                        className="inline-flex items-center"
                    >
                        <IconPlus className="mr-2" />
                        <span>New</span>
                    </Button>
                </div>

                <div className="w-full md:mt-8 md:p-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {agents?.map((data: any, index: number) => {
                        const agent = JSON.parse(data.raw_data);

                        console.log(agent)
                        const config = genConfig(agent?.agentProfile?.title);

                        return (
                        <div
                            key={index}
                            className="card card-hover shadow-sm border border-gray-200 bg-white rounded-lg h-40 relative p-4 group"
                            onClick={() => ViewAgent(data)}
                        >
                            <div className="edit-button absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <button
                                className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center bg-white focus:border-blue-500 focus:border-2"
                                onClick={(e) => {
                                e.stopPropagation();
                                EditAgent(data.id, agent);
                                }}
                            >
                                <IconPencil size={16} />
                            </button>
                            </div>
                            <div className="">
                            <div className="flex justify-between items-center">
                                <h2 className="card-title inline-flex items-center gap-2">
                                <Avatar style={{ width: '3rem', height: '2.9rem' }} {...config} />
                                <h3 className="agent-title">{agent?.agentProfile?.title}</h3>
                                </h2>
                            </div>
                            <p className="text-sm text-muted-foreground line-clamp-2">
                                {agent?.agentProfile?.description}
                            </p>
                            <div className="flex w-full flex-row gap-6 items-center justify-between mt-2">
                                <div className="inline-block text-left">
                                <div
                                    className="border border-gray-300 bg-white rounded-lg md:py-1 md:px-2 cursor-pointer hover:bg-gray-300"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggle(data.id);
                                    }}
                                >
                                    <IconDots size={20} />
                                </div>
                                {openDropdownId === data.id && (
                                    <div className="card border rounded-lg shadow-lg p-2 z-50 flex flex-col absolute bg-white" ref={dropdownRef}>
                                    <button
                                        className="text-sm rounded-lg px-4 py-2 hover:bg-gray-200 focus:outline-none"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        // Handle Duplicate action
                                        }}
                                        
                                    >
                                        Duplicate
                                    </button>
                                    <button
                                        className="text-sm rounded-lg px-4 py-2 hover:bg-gray-200 focus:outline-none"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        // Handle Delete action
                                        deleteAgents(data?.id)
                                        }}
                                    >
                                        Delete
                                    </button>
                                    </div>
                                )}
                                </div>
                                <div className="inline-flex gap-2">
                                <button
                                    className="inline-flex items-center md:py-1 md:px-2 rounded-lg border border-gray-300 justify-end hover:bg-gray-200"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    ViewAgent(data);
                                    }}
                                >
                                    <IconEye size={16} />
                                </button>
                                <button
                                    className="inline-flex items-center md:py-1 md:px-2 rounded-lg border border-gray-300 justify-end bg-black text-white"
                                    onClick={(e) => { 
                                        e.stopPropagation();
                                        UseAgent(data);
                                    }}
                                >
                                    <span className="pe-1 pb-0.5">Use agent</span>
                                    <IconChevronRight size={16} />
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                        );
                    })}
                    </div>
            </div>
        </div>
    );
}
